<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline"><slot name = "title"/></v-card-title>
        <v-card-text><slot name = "text"/></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="dialog = false;$emit('no')">No</v-btn>
          <v-btn color="blue" text @click="dialog = false;$emit('yes')">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  }
};
</script>